import React, { useRef, useEffect } from 'react';
import Matter, { Svg } from 'matter-js';
import {random} from "gsap/gsap-core";
import '../../../App.css';

const Projects = () => {


    return (<section id={"projects"}>
            <div className={"section-container project-container"} >
                <h1>Projects</h1>
            </div>
    </section>
        );
};

export default Projects;
